import { render, staticRenderFns } from "./FellowshipPlan.vue?vue&type=template&id=71d479f2&"
import script from "./FellowshipPlan.vue?vue&type=script&lang=js&"
export * from "./FellowshipPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports